const ErrorType = {
  HTTP_200: 200,
  HTTP_400: 400,
  HTTP_401: 401,
  HTTP_403: 403,
  HTTP_500: 500,
  HTTP_503: 503,
};

export default { ...ErrorType };
